import {useTypedSelector} from "../../../hooks/useTypedSelector";
import './Counters.css';

function Counters({side}) {

    const {counters} = useTypedSelector(state => state.game);

    let rootClass = 'countersContainer playerCountersContainer';
    let deckCount = counters.player.deck_count;
    let handCount = counters.player.hand_count;
    if (side === 'cpu') {
        rootClass = 'countersContainer cpuCountersContainer';
         deckCount = counters.cpu.deck_count;
         handCount = counters.cpu.hand_count;
    }

    return <div className={rootClass}>
        <div className={'handCounter'}>
            <div className={'handCountIco'}></div>
            <div className={'handAmount font-oswald-bold'}>{handCount}</div>
        </div>
        <div className={'deckCounter'}>
            <div className={'deckCountIco'}></div>
            <div className={'deckAmount font-oswald-bold'}>{deckCount}</div>
        </div>
    </div>
}

export default Counters